import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Reports|Import Statistics|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPReportsImportStatistics';
export type SPReportsImportStatisticsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelStarted`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelTotalRecords`
	| `${LocNameStart}LabelCandidates`
	| `${LocNameStart}LabelExams`
	| `${LocNameStart}LabelSections`
	| `${LocNameStart}LabelItems`
	| `${LocNameStart}LabelResponses`
	| `${LocNameStart}LabelSurveys`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}LabelCredentialRequirements`;

export const spReportsImportStatisticsLocs: LocDefs<SPReportsImportStatisticsLocNames> = {
	SPReportsImportStatisticsTitlePage: {
		defaultValue: 'Import Statistics',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.ImportStatistics.Title.PageTitle',
		...sharedProperties,
	},
	SPReportsImportStatisticsTitleSection: {
		defaultValue: 'Import Statistics',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.ImportStatistics.Title.SectionTitle',
		...sharedProperties,
	},
	SPReportsImportStatisticsTitleTab: {
		defaultValue: 'Import Statistics',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Core/Reporting.ImportStatistics.Title.TabTitle',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelStarted: {
		defaultValue: 'Started',
		description: 'Column heading for: Started.',
		displayPath: `${pathStart}Started`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Started',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelTotalRecords: {
		defaultValue: 'Total Records',
		description: 'Column heading for: Total Records.',
		displayPath: `${pathStart}Total Records`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.TotalRecords',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelCandidates: {
		defaultValue: 'Candidates',
		description: 'Column heading for: Candidates.',
		displayPath: `${pathStart}Candidates`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Candidates',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelExams: {
		defaultValue: 'Exams',
		description: 'Column heading for: Exams.',
		displayPath: `${pathStart}Exams`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Exams',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelSections: {
		defaultValue: 'Sections',
		description: 'Column heading for: Sections.',
		displayPath: `${pathStart}Sections`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Sections',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelItems: {
		defaultValue: 'Items',
		description: 'Column heading for: Items.',
		displayPath: `${pathStart}Items`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Items',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelResponses: {
		defaultValue: 'Responses',
		description: 'Column heading for: Responses.',
		displayPath: `${pathStart}Responses`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Responses',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelSurveys: {
		defaultValue: 'Surveys',
		description: 'Column heading for: Surveys.',
		displayPath: `${pathStart}Surveys`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Surveys',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelComments: {
		defaultValue: 'Comments',
		description: 'Column heading for: Comments.',
		displayPath: `${pathStart}Comments`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.Comments',
		...sharedProperties,
	},
	SPReportsImportStatisticsLabelCredentialRequirements: {
		defaultValue: 'Credential Requirements',
		description: 'Column heading for: Credential Requirements.',
		displayPath: `${pathStart}Credential Requirements`,
		displayType: 'Label',
		legacyName: 'Core/Reporting.ImportStatistics.ColumnHeading.CredentialRequirements',
		...sharedProperties,
	},
};

export type SPReportsImportStatisticsLocType = LocMap<SPReportsImportStatisticsLocNames>;
